import { Component, OnInit } from '@angular/core';
import { PrintService } from 'src/app/services/print.service';
import { TESTING_CENTER } from 'src/app/dummy/tab';
import { PlacementTest } from 'src/app/stores/testingCenter/placementTest.store';

@Component({
  selector: 'app-book-club',
  templateUrl: './book-club.component.html',
  styleUrls: ['./book-club.component.scss']
})
export class BookClubComponent implements OnInit {
  tabs = TESTING_CENTER.BOOK_CLUB;

  constructor(
    public store: PlacementTest,
    public ps: PrintService,
  ) { }

  ngOnInit() {
    this.store.fetchClass()
  }


}
